import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
	backdrop: {
		zIndex: theme.zIndex.modal + 1,
		color: '#fff',
	},
	filtersCard: {
		padding: theme.spacing(2.5),
		borderRadius: theme.spacing(2),
		marginBottom: theme.spacing(2),
		background: 'white',
		boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
		border: '1px solid rgba(0,0,0,0.05)',
	},
	toolbarRow: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		flexWrap: 'wrap',
		gap: theme.spacing(1.5),
	},
	toolbarActions: {
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing(1),
	},
	resultsCount: {
		color: theme.palette.text.secondary,
		fontSize: '0.875rem',
		whiteSpace: 'nowrap',
	},
	tablePaper: {
		borderRadius: theme.spacing(2),
		overflow: 'hidden',
		border: '1px solid rgba(0,0,0,0.08)',
		boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
	},
	tableHeader: {
		backgroundColor: theme.palette.primary.main,
		color: 'white',
		fontWeight: 600,
	},
	tableRow: {
		cursor: 'pointer',
		'&:hover': {
			backgroundColor: 'rgba(0,0,0,0.04)',
		},
	},
	paginationBar: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginTop: theme.spacing(2),
		flexWrap: 'wrap',
		gap: theme.spacing(1),
	},
	actionsCell: {
		whiteSpace: 'nowrap',
	},
}));
